<template>
  <div class="ShipsCargoGearsCapacity flex-jc-bt">
    <div class="flex-50 left-side">
      <SpCard custom-class="sp-color-bg-4 card-content">
        <SpRadioGroup v-model="shipInfo.gearType" name="gearType">
          <div class="flex-al-start flex-col item">
            <SpRadio class="radio-label-left" value="0">
              <span class="label sp-color-11 text-left">{{ $l('Gearless') }}</span>
            </SpRadio>
            <div class="flex-al-center flex-no-wrap mg-t-10 width-100">
              <SpRadio :value="1">
                <span class="label sp-color-11">{{ $l('GearedGearType') }}</span>
              </SpRadio>
              <SpInput v-show="shipInfo.gearType=== 1"
                       v-model="shipInfo.gearTypeDetail"
                       :validate-reg="/^((?=.*[a-zA-Z])[A-Za-z0-9-+=—.,\/()&:’”\s]{3,64})?$/"
                       name="gearTypeDetail" class="flex-70 flex-grow" type="warn" :width="1" />
            </div>
          </div>
        </SpRadioGroup>
        <div v-show="shipInfo.gearType=== 1" class="flex-jc-end">
          <div class="flex-75 flex-jc-ard">
            <SpIcon type="doubleSelect" />
            <SpIcon type="doubleSelect" />
          </div>
        </div>
        <div v-show="shipInfo.gearType ===1" class="flex mg-t-10">
          <div class="flex-25">
            <div class="fs-int mg-t-100">{{ $l('TheSWLMT') }}</div>
            <div class="fs-int mg-t-30">{{ $l('HowmanySets') }}</div>
            <div v-title class="fs-int mg-t-50">{{ $l('OutReach') }}</div>
            <div v-title class="fs-int mg-t-30">{{ $l('MAXReach') }}</div>
            <div class="fs-int mg-t-50">{{ $l('Canbecombined') }}</div>
          </div>
          <div class="flex-75 flex-jc-ard">
            <div class="card flex-49 sp-color-bd-1-dashed-7">
              <div>
                <SpRadio v-model="shipInfo.cranes" :value="1">
                  <span class="fs-bold sp-color-11">{{ $l('Cranes') }}</span>
                </SpRadio>
                <SpIcon class="mg-t-10" type="doubleSelect" />
              </div>
              <div class="border-box flex-al-center mg-t-10">
                <SpInput v-model="shipInfo.crane.swlMin"
                         :max="1000" :min="1" :precision="2" text-type="number"
                         :disabled="!shipInfo.cranes" :type="!shipInfo.cranes? 'gray' : 'warn'"
                         :placeholder="$l('MIN')" class="flex-40" />
                <span class="flex-10 fs-ini opacity-50">-</span>
                <SpInput v-model="shipInfo.crane.swlMax"
                         :max="1000" :min="1" :precision="2" text-type="number"
                         :disabled="!shipInfo.cranes" :type="!shipInfo.cranes? 'gray' : 'warn'"
                         :placeholder="$l('MAX')" class="flex-40" />
                <span class="flex-10 fs-ini opacity-50">{{ $L('MT') }}</span>
              </div>
              <div class="border-box flex-al-center mg-t-5">
                <SpSelect v-model="shipInfo.crane.amount" :disabled="!shipInfo.cranes" :type="!shipInfo.cranes? 'gray' : 'warn'" class="flex-40">
                  <SpSelectOption v-for="n in 5" :key="n" :label="n" :value="n" />
                </SpSelect>
                <span class="flex-10 fs-ini opacity-50">{{ $l('Sets') }}</span>
              </div>
              <div class="border-box flex-al-center mg-t-20">
                <SpInput v-model="shipInfo.crane.outreach"
                         :max="20" :min="0" :precision="2" text-type="number"
                         :placeholder="$l('OutReach')" :disabled="!shipInfo.cranes" :type="!shipInfo.cranes? 'gray' : 'warn'" class="flex-40" />
                <span class="flex-10 fs-ini opacity-50">{{ $l('M') }}</span>
              </div>
              <div class="border-box flex-al-center mg-t-5">
                <SpInput v-model="shipInfo.crane.maxReach"
                         :max="20" :min="0" :precision="2" text-type="number"
                         :placeholder="$l('MAXReach')" :disabled="!shipInfo.cranes" :type="!shipInfo.cranes? 'gray' : 'warn'" class="flex-40" />
                <span class="flex-10 fs-ini opacity-50">{{ $l('M') }}</span>
              </div>
              <div class="flex mg-t-30">
                <SpRadio v-model="shipInfo.craneYesCombined" :value="1">
                  <span class="fs-int opacity-50">{{ $l('YesCombinedSWLis') }}</span>
                </SpRadio>
              </div>
              <div class="border-box flex-al-center mg-t-10">
                <SpInput v-model="shipInfo.crane.swlCombinedMin"
                         :max="1000" :min="1" :precision="2" text-type="number"
                         :disabled="!shipInfo.craneYesCombined" :type="!shipInfo.craneYesCombined? 'gray' : 'warn'" :placeholder="$l('MIN')" class="flex-40" />
                <span class="flex-10 fs-ini opacity-50">-</span>
                <SpInput v-model="shipInfo.crane.swlCombinedMax"
                         :max="1000" :min="1" :precision="2" text-type="number"
                         :disabled="!shipInfo.craneYesCombined" :type="!shipInfo.craneYesCombined? 'gray' : 'warn'" :placeholder="$l('MAX')" class="flex-40" />
                <span class="flex-10 fs-ini opacity-50">{{ $L('MT') }}</span>
              </div>
            </div>
            <div class="card flex-49 sp-color-bd-1-dashed-7">
              <div>
                <SpRadio v-model="shipInfo.derricks" :value="2">
                  <span class="fs-bold sp-color-11">{{ $l('Derricks') }}</span>
                </SpRadio>
                <SpIcon class="mg-t-10" type="doubleSelect" />
              </div>
              <div class="border-box flex-al-center mg-t-10">
                <SpInput v-model="shipInfo.derrick.swlMin"
                         :max="1000" :min="1" :precision="2" text-type="number"
                         :disabled="!shipInfo.derricks" :type="!shipInfo.derricks? 'gray' : 'warn'" :placeholder="$l('MIN')" class="flex-40" />
                <span class="flex-10 fs-ini opacity-50">-</span>
                <SpInput v-model="shipInfo.derrick.swlMax"
                         :max="1000" :min="1" :precision="2" text-type="number"
                         :disabled="!shipInfo.derricks" :type="!shipInfo.derricks? 'gray' : 'warn'" :placeholder="$l('MAX')" class="flex-40" />
                <span class="flex-10 fs-ini opacity-50">{{ $L('MT') }}</span>
              </div>
              <div class="border-box flex-al-center mg-t-5">
                <SpSelect v-model="shipInfo.derrick.amount"
                          :disabled="!shipInfo.derricks" :type="!shipInfo.derricks? 'gray' : 'warn'" class="flex-40">
                  <SpSelectOption v-for="n in 5" :key="n" :label="n" :value="n" />
                </SpSelect>
                <span class="flex-10 fs-ini opacity-50">{{ $l('Sets') }}</span>
              </div>
              <div class="border-box flex-al-center mg-t-20">
                <SpInput v-model="shipInfo.derrick.outreach"
                         :max="20" :min="0" :precision="2" text-type="number"
                         :placeholder="$l('OutReach')" :disabled="!shipInfo.derricks" :type="!shipInfo.derricks? 'gray' : 'warn'" class="flex-40" />
                <span class="flex-10 fs-ini opacity-50">{{ $l('M') }}</span>
              </div>
              <div class="border-box flex-al-center mg-t-5">
                <SpInput v-model="shipInfo.derrick.maxReach"
                         :max="20" :min="0" :precision="2" text-type="number"
                         :placeholder="$l('MAXReach')" :disabled="!shipInfo.derricks" :type="!shipInfo.derricks? 'gray' : 'warn'" class="flex-40" />
                <span class="flex-10 fs-ini opacity-50">{{ $l('M') }}</span>
              </div>
              <div class="flex mg-t-30">
                <SpRadio v-model="shipInfo.derricksYesCombined" :value="1">
                  <span class="fs-int">{{ $l('YesCombinedSWLis') }}</span>
                </SpRadio>
              </div>
              <div class="border-box flex-al-center mg-t-10">
                <SpInput v-model="shipInfo.derrick.swlCombinedMin"
                         :max="1000" :min="1" :precision="2" text-type="number"
                         :disabled="!shipInfo.derricksYesCombined" :type="!shipInfo.derricksYesCombined? 'gray' : 'warn'" :placeholder="$l('MIN')" class="flex-40" />
                <span class="flex-10 fs-ini opacity-50">-</span>
                <SpInput v-model="shipInfo.derrick.swlCombinedMax"
                         :max="1000" :min="1" :precision="2" text-type="number"
                         :disabled="!shipInfo.derricksYesCombined" :type="!shipInfo.derricksYesCombined? 'gray' : 'warn'" :placeholder="$l('MAX')" class="flex-40" />
                <span class="flex-10 fs-ini opacity-50">{{ $L('MT') }}</span>
              </div>
            </div>
          </div>
        </div>
      </SpCard>
      <p class="reminder">{{ $l('Reminder') }}</p>
    </div>
    <div class="flex-48 mg-t-40 right-side sp-color-bg-4">
      <ShipInfoTable v-model="shipInfo" />
      <div class="outer-gap sp-color-11 text-left title">{{ $l('SomeSupportingFilesPicturesPDForOthers') }}</div>
      <div class="mg-t-20 sp-color-11 text-left title-tip">{{ $l('Picturesofgearsrelatedtothisship') }}</div>
      <SpUploadGroup class="mg-t-20" :business-id="shipInfo.businessId" file-type="ship/gear/pic" accept="image/*" />
      <div class="mg-t-20 sp-color-11 text-left title-tip">{{ $l('Shipgearscertificatesrelatedtotheship') }}</div>
      <SpUploadGroup class="mg-t-20" :business-id="shipInfo.businessId" file-type="ship/gear/cert" accept="image/*" />
      <div class="mg-t-20 sp-color-11 text-left title-tip">{{ $l('Others') }}</div>
      <SpUploadGroup class="mg-t-20" :business-id="shipInfo.businessId" file-type="ship/gear/other" accept="image/*" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SpCard from '@/components/common/SpCard'
import SpInput from '@/components/common/SpInput'
import SpSelect from '@/components/common/SpSelect'
import SpUploadGroup from '@/components/common/SpUploadGroup'
import SpRadio from '@/components/common/SpRadio'
import SpRadioGroup from '@/components/common/SpRadioGroup'
import SpIcon from '@/components/common/SpIcon'
import ShipInfoTable from '@/components/shipOwner/tonnages/newTonnage/ShipInfoTable'
import SpSelectOption from '@/components/common/SpSelectOption'
export default {
  name: 'ShipsCargoGearsCapacity',

  nameSpace: 'shipOwner.tonnages.newTonnage.ShipsCargoGearsCapacity',

  components: {
    SpSelectOption,
    SpCard,
    SpInput,
    SpSelect,
    SpUploadGroup,
    SpRadio,
    SpIcon,
    ShipInfoTable,
    SpRadioGroup
  },

  props: {
    modelValue: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  emits: ['update:modelValue'],

  data () {
    return {
    }
  },

  computed: {
    shipInfo: {
      get () {
        return this.modelValue
      },

      set (nv) {
        this.$emit('update:modelValue', nv)
      }
    }
  },

  created () {
  },

  mounted () {
  },

  methods: {
  }
}
</script>

<style scoped lang="less">
.ShipsCargoGearsCapacity{
  .card-content{
    padding: @gap;
    .card{
      box-sizing: border-box;
      padding: @gap;
    }
    .label{
      font-size: 18px;
      font-family: Arial;
      font-weight: 400;
    }
    .label-bold{
      font-size: 18px;
      font-family: Arial;
      font-weight: bold;
    }
  }
  .right-side{
    box-sizing:border-box;
    padding:@gap;
    .title{
      font-size: 18px;
      font-family: Arial;
      font-weight: 400;
    }
    .title-tip{
      font-size: 18px;
      font-family: Arial;
      font-weight: 400;
      opacity: 0.5;
    }
  }
  .outer-gap{
    margin-top: @gap*3;
  }
}
</style>

<style lang="less">
.radio-label-left {
  .label-right {
      text-align: left !important;
  }
}
</style>
